var map = {
	"./cgjz-1.jpg": "5230",
	"./cgjz-2.jpg": "3831",
	"./cgjz-3.jpg": "dc6e",
	"./cgjz-4.jpg": "4355",
	"./cgjz-5.jpg": "4e01",
	"./cgjz-6.jpg": "7a9c",
	"./cgjz-7.jpg": "3655",
	"./cgjz-8.jpg": "7214",
	"./lanmu-01.jpg": "cf50",
	"./lanmu-02.jpg": "8b30",
	"./lanmu-03.jpg": "7301",
	"./lanmu-04.jpg": "93cc",
	"./lanmu-05.jpg": "0212",
	"./lanmu-06.jpg": "009c",
	"./szb.jpg": "510b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52bd";